import React from 'react'
import { Box } from '@mui/material'
import { HomeHero, HomeAbout,  HomeServices, HomeCareer } from '../containers';
import { Footer } from '../components';
import { logoTransparent } from '../assets';


const Home = ({sx}) => {
  return (
    <Box
      sx={{
        minHeight: '75vh',
        ...sx,
      }}
    >
      <HomeHero />
      <HomeServices />
      <HomeAbout />
      <Box
        sx={{
          display:'flex',
          justifyContent:'space-between',
          alignContent:'center',
          background:'linear-gradient(to right, #A6A6A6, #fefefe)',
        }}
      >
        <HomeCareer />
        <Box
          sx={{
            overflow: 'hidden',
            width: '50%',        // Only show left half
            position: 'relative',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            '@media screen and (max-width:762px)':{
              width:'30%'
            }
          }}
        >
        <Box
          component="img"
          src={logoTransparent}
          sx={{
            width: '50%', // Keep image size normal
            objectFit: 'contain',
            transform: 'translateX(150%)', // Shift image left so only left half shows
            '@media screen and (max-width:762px)':{
              width:'100%',
              transform:'translate(50%)',
            }
          }}
        />
      </Box>


      </Box>
      <Footer />
    </Box>
  )
}

export default Home